import useTranslator from "../../../hooks/useTranslator";
import { useContext, useEffect, useState } from "react";
import AddSubLLModal from "./AddSubLLModal";
import LandLordContext from "../../../context/landlord/LandLordContext";
import { haveValue } from "../../../helper/common";
import UserIcon from "../../../assets/img/user-icon.svg";

const SubLandlord = () => {
  const { _t } = useTranslator();
  const landLordContext = useContext(LandLordContext);
  const { getSubLL } = landLordContext;

  const [showAddSubLL, setShowAddSubLL] = useState(false);
  const [subLandlordList, setSubLandlordList] = useState(null);

  useEffect(() => {
    fetchSubLL();
  }, []);

  const handleShowModal = () => {
    setShowAddSubLL(true);
  };

  const handleCloseModal = () => {
    setShowAddSubLL(false);
    fetchSubLL();
  };

  const fetchSubLL = () => {
    getSubLL()
      .then((res) => {
        const temp_list = res?.data?.landlord_list;
        setSubLandlordList(temp_list);
      })
      .catch((err) => {
        console.log(err, "Error in fetchSubLL");
      });
  };

  return (
    <div className="main-page-wrapper profileRequestWrapper">
      {showAddSubLL && (
        <AddSubLLModal
          showAddSubLL={showAddSubLL}
          handleCloseModal={handleCloseModal}
        />
      )}
      <div className="number-properties numberProperties">
        <h2>{_t("users")}</h2>
        <div className="d-flex align-items-center propertySearchWrapper">
          <div className="Search-bar searchbar_cls">
            <div className="search_bar_edit">
              <a href="#">
                <img
                  src="/images/search-icon-grey.svg"
                  alt=""
                  className="searchIcon"
                />
              </a>
              <input
                type="text"
                className="custom-input mb-0 input01"
                placeholder={_t("searchProperty")}
              />
            </div>
          </div>
          <button
            className="addGuarantorButton d-flex mx-0"
            onClick={handleShowModal}
          >
            <img src="/images/add-white.svg" />
            {_t("addSubLL")}
          </button>
        </div>
      </div>
      <div className="tabs-box-pattern mobile big_tablebg">
        <div className="upcoming-box">
          <table className="upcoming-table landlord-table bigtable_set">
            <thead className="hideOnMobile">
              <tr className="first-row">
                <th> {_t("name")} </th>
                <th> {_t("email")} </th>
                <th> {_t("propertyCount")} </th>
              </tr>
            </thead>

            <tbody className="hideOnMobile">
              {haveValue(subLandlordList)
                ? subLandlordList.map((data) => (
                  <>
                    <tr className="second-row">
                      <td>
                        {data?.fname_companyName || ""} {data?.lname || ""}
                      </td>
                      <td>{data?.email}</td>
                      <td>{data?.properties?.length}</td>
                    </tr>
                  </>
                ))
                : _t("noDetailsFound")}
            </tbody>
            {haveValue(subLandlordList)
              ? subLandlordList.map((data) => (
                <>
                  <div
                    className="table-mobile-card hideOnDesktop"
                  >
                    {/* Tenant */}
                    <div
                      className="d-flex justify-content-between gap-3 align-items-center mb-3 cursor-pointer"

                    >
                      <div className="d-flex justify-content-start gap-3 align-items-center">
                        <div className="earner-thumbnail-wrapper d-flex items-center justify-center mr-3">
                          <img src={UserIcon} alt="User Icon" />
                        </div>
                        <div className="main-text">
                          {data?.fname_companyName || ""} {data?.lname || ""}
                        </div>
                      </div>
                    </div>

                    {/* Score */}
                    <div className="table-mobile-card-comp table-mobile-card-users-comp">
                      {" "}
                      <div
                        className="table-mobile-card-data cursor-pointer"
                      >
                        <p className="text-gray-500">{_t("email")}</p>
                        <span className="card-text">
                          {data?.email}
                        </span>
                      </div>
                      <div
                        className="table-mobile-card-data cursor-pointer"
                      >
                        <p className="text-gray-500">{_t("propertyCount")}</p>
                        <span className="card-text">{data?.properties?.length}</span>
                      </div>
                    </div>
                  </div>
                </>
              ))
              : _t("noDetailsFound")}
          </table>
        </div>
      </div>
    </div>
  );
};

export default SubLandlord;
